export default {
    methods: {
        toggleCategory(category) {
            let newCategories = this.selectedCategories.slice()
            const index = newCategories.findIndex(c => c.id === category.id)
            if (index >= 0) {
                newCategories.splice(index, 1)
            }
            if (index < 0) {
                newCategories.push(category)
            }

            return newCategories
        },
    }
};
